/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  changePassword: {},
}

export const fetchAsyncChangePassword: any = createAsyncThunk(
  'changePassword/fetchAsyncChangePassword',
  async (data) => {
    const response = await axios
      .post(`${API_URL}user/change-password`, data, {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res) => {
        res.data.status === true && toast.success(res.data.message)
      })
    return response
  }
)

const ChangePasswordSlice = createSlice({
  name: 'changePassword',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncChangePassword.pending]: (state) => {},
    [fetchAsyncChangePassword.fulfilled]: (state, {payload}) => {
      return {...state, changePassword: payload}
    },
  },
})

export default ChangePasswordSlice.reducer
